// Compare ordering terms, not administrative metadata or harmless stock movements.
export const menuCategoryOrderTerms = (categories, quantities = {}) => (categories || []).map(category => ({
  id: category.id, name: category.name, system_key: category.system_key,
  posting_account: category.posting_account, is_archived: Boolean(category.is_archived),
  products: (category.products || []).map(product => ({
    id: product.id, name: product.name, price: product.price,
    available: !product.stock_enabled || product.stock_quantity >= Math.max(1, quantities[product.id] || 0),
  })),
}));

export const getVisibleMenuCategories = (categories = [], departmentConfig = {}) => (
  categories.filter((category) => {
    if (category.system_key === 'drinks') {
      return departmentConfig.is_drinks_enabled !== false;
    }
    if (category.system_key === 'snacks') {
      return departmentConfig.is_snacks_enabled !== false;
    }
    return !category.is_archived && (category.products || []).length > 0;
  })
);

export const buildMenuCategoryOrderPayload = (
  category,
  quantities,
  employeeId,
  departmentId
) => {
  const basePayload = {
    employee_id: employeeId,
    department_id: departmentId,
    order_type: category.system_key || 'category',
    breakfast_items: [],
    drink_items: {},
    sweet_items: {},
  };

  if (category.system_key === 'drinks') {
    return { ...basePayload, drink_items: quantities };
  }
  if (category.system_key === 'snacks') {
    return { ...basePayload, order_type: 'sweets', sweet_items: quantities };
  }
  return {
    ...basePayload,
    menu_category_id: category.id,
    category_items: quantities,
  };
};
